import { MainInner, StyledMainSection } from "@/styles/global";
import { Body, H2, H3, SmallHeading2 } from "@/styles/typography";
import { Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import styled, { css } from "styled-components";

const Section = styled(StyledMainSection)`
  background-color: ${({ theme }) => theme.colors.creme};

  padding: 24px 0 48px 0;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    margin: 0;
    padding: 44px 0 88px 0;
  }
`;

const Inner = styled(MainInner)``;

const RelatedTitle = styled(H3)`
  color: ${({ theme }) => theme.colors.black};
  margin-bottom: 32px;
`;

const CardsScroller = styled(MainInner)`
  width: 100%;
  max-width: 100%;
  overflow-x: scroll;
  padding-bottom: 32px;
`;

const CardsContainer = styled(MainInner)`
  flex-direction: row;
  gap: 16px;
  overflow-x: scroll;
  width: fit-content(100%);
  overflow: visible;
`;

const CardCss = css<{ $external: boolean }>`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.black};
  border-radius: 14px;
  overflow: hidden;
  text-decoration: none;
  width: 100%;
  min-width: 300px;
  max-width: 80vw;
  height: 413px;

  svg {
    transition: transform 0.3s;
    transform: ${({ $external }) => ($external ? "rotate(-45deg)" : "none")};
  }

  &:hover {
    svg {
      transform: ${({ $external }) =>
        $external ? "rotate(-45deg) translateX(10px)" : "translateX(10px)"};
    }
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    height: 453px;
    width: 308px;
    max-width: 308px;
  }
`;

const Card = styled(Link)<{ $external: boolean }>`
  ${CardCss}
`;

const CardExternal = styled.a<{ $external: boolean }>`
  ${CardCss}
`;

const ImageCss = css`
  width: 100%;
  height: 228px;
  flex-shrink: 0;
`;
const CardImage = styled(GatsbyImage)`
  ${ImageCss}
`;

const CardLocalImage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  ${ImageCss}
  padding: 16px;

  svg {
    width: 100%;
    height: 100%;
  }
`;

const CardTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 24px;
  height: 100%;
`;

const CardDate = styled(Body)`
  margin-bottom: 8px;
  color: ${({ theme }) => theme.colors.creme};
  font-size: 16px;
`;

const CardTitle = styled(H3)`
  color: ${({ theme }) => theme.colors.creme};
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    -webkit-line-clamp: 3;
  }
`;

const CardReadMoreWrapper = styled.div`
  display: flex;
  margin-top: auto;
  justify-content: space-between;
`;

const CardReadMore = styled(SmallHeading2)`
  color: ${({ theme }) => theme.colors.creme};
  width: max-content;
`;

const S = {
  Section,
  Inner,
  RelatedTitle,
  CardsScroller,
  CardsContainer,
  Card,
  CardExternal,
  CardImage,
  CardLocalImage,
  CardTextWrapper,
  CardDate,
  CardTitle,
  CardReadMoreWrapper,
  CardReadMore,
};

export default S;
